/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateMainContactDto = {
    /**
     * Preferred name for the main contact
     */
    preferredName?: string;
    /**
     * Last name of the main contact. Required when mainContact is supplied.
     */
    lastName: string;
    /**
     * Email address of the main contact
     */
    email?: string;
    /**
     * Preferred phone type for communication
     */
    preferredPhone?: UpdateMainContactDto.preferredPhone;
    /**
     * Mobile phone number
     */
    mobile?: string;
    /**
     * Home phone number
     */
    homePhone?: string;
    /**
     * Work phone number
     */
    workPhone?: string;
    /**
     * External reference ID from another system
     */
    externalReference?: string;
};
export namespace UpdateMainContactDto {
    /**
     * Preferred phone type for communication
     */
    export enum preferredPhone {
        MOBILE = 'MOBILE',
        HOME = 'HOME',
        WORK = 'WORK',
    }
}

